export enum FileUploadAllowedFiles {
  Svg = 'image/svg+xml',
  Png = 'image/png',
  Pdf = 'application/pdf',
  Jpg = 'image/jpeg',
  Gif = 'image/gif',
  Bmp = 'image/bmp',
  Csv = 'text/csv',
  Doc = 'application/msword',
  Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  Txt = 'text/plain',
  Zip = 'application/zip'
}

export const fileTypeExtensionMap: Record<FileUploadAllowedFiles, string[]> = {
  [FileUploadAllowedFiles.Svg]: ['.svg'],
  [FileUploadAllowedFiles.Png]: ['.png'],
  [FileUploadAllowedFiles.Pdf]: ['.pdf'],
  [FileUploadAllowedFiles.Jpg]: ['.jpg', '.jpeg'],
  [FileUploadAllowedFiles.Gif]: ['.gif'],
  [FileUploadAllowedFiles.Bmp]: ['.bmp'],
  [FileUploadAllowedFiles.Csv]: ['.csv'],
  [FileUploadAllowedFiles.Doc]: ['.doc'],
  [FileUploadAllowedFiles.Docx]: ['.docx'],
  [FileUploadAllowedFiles.Txt]: ['.txt'],
  [FileUploadAllowedFiles.Zip]: ['.zip']
};
